import React from "react";
import ArrowSvg from "../../assets/taiga-uikit/icons/arrow-right-1.svg?react";
import { _size, _sizeText } from "../../core/core";
import { Text } from "../texts/text";
import "./TabSelection.css";

interface TabSelectionProps {
  onClick: () => void;
  isActive?: boolean;
  size?: _size;
  children?: React.ReactNode;
}

export const TabSelection: React.FC<TabSelectionProps> = ({
  onClick,
  isActive = false,
  size = _size.M,
  children,
  ...props
}) => {
  return (
    <div
      onClick={onClick}
      className={`tab-selection ${size} tab-selection-${isActive}`}
      {...props}
    >
      <div className="tab-selection-body">
        <Text size={_sizeText.hmp2}>{children}</Text>
      </div>
      <ArrowSvg />
    </div>
  );
};
